'use strict';

export default (() => {

    var _self,
        ui,
        wrap;

    return {

        init: function(options) {
            _self = this;

            if (options.wrap) {
                wrap = options.wrap;
            }

            if (wrap) {
                ui = {
                    mobileSearchToggles: document.querySelectorAll('.js-mobile-search-toggle')
                };
                this.bindUIActions();
            }
        },

        bindUIActions: function() {
            if (ui.mobileSearchToggles.length) {
                for (var i = 0; i <  ui.mobileSearchToggles.length; i++) {
                    ui.mobileSearchToggles[i].addEventListener('click', _self.events.mobileSearchToggleClick);
                }
            }
        },

        events: {
            mobileSearchToggleClick: function(e) {
                e.preventDefault();
                _self.toggleMobileSearch();
            }
        },

        toggleMobileSearch: function() {
            if (document.body.classList.contains('is-showing-mobile-nav')) {
                document.body.classList.remove('is-showing-mobile-nav');
                setTimeout(function() {
                    document.body.classList.toggle('is-showing-mobile-search');
                }, 500);
            } else {
                document.body.classList.toggle('is-showing-mobile-search');
            }
        }
    };
})();
